import React from "react";
import { Printer } from "lucide-react";

export default function Logo({ size = 32, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="app-logo">
      <div
        className="relative flex items-center justify-center rounded-lg"
        style={{
          width: size,
          height: size,
          background: "linear-gradient(135deg, #0F62FE 0%, #10B981 100%)",
        }}
      >
        <Printer size={size * 0.6} className="text-white" strokeWidth={2.4} />
      </div>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-display font-bold text-lg tracking-tight">
            Maa<span className="text-brand-blue">Print</span>
          </span>
          <span className="text-[10px] text-muted-foreground uppercase tracking-widest -mt-0.5">
            Cloud Print
          </span>
        </div>
      )}
    </div>
  );
}
